import { render, staticRenderFns } from "./ChatApp.vue?vue&type=template&id=aa69d3ca&scoped=true&"
import script from "./ChatApp.vue?vue&type=script&lang=js&"
export * from "./ChatApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa69d3ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatPreload: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatPreload.vue').default,ChatLogin: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatLogin.vue').default,ChatTabPanel: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatTabPanel.vue').default})
